import React from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styled, { css, keyframes } from 'styled-components';
import { PagesRoutes } from '../../store/routes';

const bonusCtaPulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);
  }
  50% {
    transform: scale(1.04);
    box-shadow: 0 16px 34px rgba(0, 0, 0, 0.36), 0 0 0 10px rgba(255, 255, 255, 0.08);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);
  }
`;

const PulseButton = styled(ButtonBase)<{ $bg: string }>`
  position: relative;
  height: 42px;
  border-radius: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  background-color: ${(p) => p.$bg};
  color: #ffffff;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);
  animation: ${(p: { disabled?: boolean }) =>
    p.disabled
      ? 'none'
      : css`
          ${bonusCtaPulse} 1.5s ease-in-out infinite
        `};
  transform-origin: center;

  &:hover {
    animation-play-state: paused;
    filter: brightness(1.03);
  }

  & .MuiTouchRipple-root {
    border-radius: 24px;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
    transition: none !important;
  }
`;

const ButtonLabel = styled.span<{ $disabled: boolean }>`
  position: relative;
  top: 1px;
  text-transform: uppercase;
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
`;

export const SellEventButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const disabled = false;

  const handleModalBtnClick = () => {
    navigate(PagesRoutes.ReferralLinkStep1);
  };

  return (
    <PulseButton
      focusRipple
      onClick={() => handleModalBtnClick()}
      disabled={disabled}
      $bg={theme.palette.secondary.main}
      style={{ marginBottom: '110px' }}
    >
      <Typography component="span" variant="subtitle1" color="inherit">
        <ButtonLabel $disabled={disabled}>{t<string>('Dashboard.EarnOnATicket')}</ButtonLabel>
      </Typography>
    </PulseButton>
  );
};
